import React from "react";
import "./CustomAlert.css";

export default function CustomAlert({ message, onClose }) {
  if (!message) return null;

  return (
    <div className="alert-overlay">
      <div className="alert-box">
        <p>{message}</p>
        <button className="alert-btn" onClick={onClose}>OK</button>
      </div>
    </div>
  );
}
